import FormCard from '@components/FormCard'
import { useHasAccess } from '@components/HasAccess'
import Page from '@components/Page/Page'
import { WhatsappBotSettingKey } from '@models/WhatsappBotSetting'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { selectSelectedVenue } from '@store/VenueReducer'
import { getWhatsappBotSettings } from '@store/WhatsappBotSettingReducer'
import { SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import MetadataKey from '@utils/MetadataKey'
import { Permission } from '@utils/permissions'
import { Alert, Col, Divider, Flex, Image, Space, Tag, Typography } from 'antd'
import { useEffect } from 'react'
const { Text } = Typography

const WhatsappBotSettingsTab = () => {
  const dispatch = useAppDispatch()
  const { hasAccess } = useHasAccess()

  const venue = useAppSelector(selectSelectedVenue())
  const venueId = venue?.id

  useEffect(() => {
    if (venueId === undefined) {
      return
    }
    dispatch(
      getWhatsappBotSettings(
        [
          WhatsappBotSettingKey.WELCOME_MESSAGE,
          WhatsappBotSettingKey.MORE_INFORMATION_FOLLOW_UP_TEXT,
          WhatsappBotSettingKey.BOOKING_FLOW_BUTTON,
          WhatsappBotSettingKey.BOOKING_FLOW_MESSAGE,
          WhatsappBotSettingKey.MANAGE_BOOKING_FLOW_BUTTON,
          WhatsappBotSettingKey.MANAGE_BOOKING_FLOW_MESSAGE,
          WhatsappBotSettingKey.AFTER_BOOKING_MESSAGE,
          WhatsappBotSettingKey.AFTER_BOOKING_UPDATE_MESSAGE,
          WhatsappBotSettingKey.AFTER_BOOKING_CANCEL_MESSAGE,
          WhatsappBotSettingKey.LINK_PAYMENT_MESSAGE,
        ],
        venueId
      )
    )
  }, [venueId])

  if (!venueId) {
    return <div>Loading...</div>
  }

  return (
    <Page rowGutter={[32, 32]} noWrapWithCol>
      <Col span={12}>
        <FormCard
          title="Welcome message"
          entity={Entity.whatsappBotSetting}
          action={SBRMAction.Update}
          disabled={!hasAccess(Permission.updateVenue)}
          metadata={[
            {
              key: MetadataKey.WhatsappBotSetting,
              value: WhatsappBotSettingKey.WELCOME_MESSAGE,
            },
            { key: MetadataKey.Venue, value: venueId },
          ]}
        />
      </Col>
      <Col span={12}>
        <Flex className="w-full" justify="center">
          <Image
            height={300}
            width={378}
            src="/assets/whatsapp-templates/welcome.png"
          />
        </Flex>
      </Col>
      <Divider />
      <Col span={12}>
        <FormCard
          title="Follow-up"
          entity={Entity.whatsappBotSetting}
          action={SBRMAction.Update}
          disabled={!hasAccess(Permission.updateVenue)}
          metadata={[
            {
              key: MetadataKey.WhatsappBotSetting,
              value: WhatsappBotSettingKey.MORE_INFORMATION_FOLLOW_UP_TEXT,
            },
            { key: MetadataKey.Venue, value: venueId },
          ]}
        />
      </Col>
      <Col span={12}>
        <Flex className="w-full" justify="center">
          <Image
            height={300}
            width={378}
            src="/assets/whatsapp-templates/follow-up.png"
          />
        </Flex>
      </Col>
      <Divider />
      <Col span={12}>
        <FormCard
          title="Booking flow button"
          entity={Entity.whatsappBotSetting}
          action={SBRMAction.Update}
          disabled={!hasAccess(Permission.updateVenue)}
          metadata={[
            {
              key: MetadataKey.WhatsappBotSetting,
              value: WhatsappBotSettingKey.BOOKING_FLOW_BUTTON,
            },
            { key: MetadataKey.Venue, value: venueId },
          ]}
        />
      </Col>
      <Col span={12}>
        <Flex className="w-full" justify="center">
          <Image
            height={300}
            width={378}
            src="/assets/whatsapp-templates/book-flow-button.png"
          />
        </Flex>
      </Col>
      <Col span={12}>
        <FormCard
          title="Booking flow text"
          entity={Entity.whatsappBotSetting}
          action={SBRMAction.Update}
          disabled={!hasAccess(Permission.updateVenue)}
          metadata={[
            {
              key: MetadataKey.WhatsappBotSetting,
              value: WhatsappBotSettingKey.BOOKING_FLOW_MESSAGE,
            },
            { key: MetadataKey.Venue, value: venueId },
          ]}
        />
      </Col>
      <Col span={12}>
        <Flex className="w-full" justify="center">
          <Image
            height={300}
            width={378}
            src="/assets/whatsapp-templates/before-book-text.png"
          />
        </Flex>
      </Col>
      <Divider />
      <Col span={12}>
        <FormCard
          title="Edit booking flow text"
          entity={Entity.whatsappBotSetting}
          action={SBRMAction.Update}
          disabled={!hasAccess(Permission.updateVenue)}
          metadata={[
            {
              key: MetadataKey.WhatsappBotSetting,
              value: WhatsappBotSettingKey.MANAGE_BOOKING_FLOW_MESSAGE,
            },
            { key: MetadataKey.Venue, value: venueId },
          ]}
        />
      </Col>
      <Col span={12}>
        <Flex className="w-full" justify="center">
          <Image
            height={300}
            width={378}
            src="/assets/whatsapp-templates/edit-cancel-text.png"
          />
        </Flex>
      </Col>
      <Col span={12}>
        <FormCard
          title="Edit booking flow button"
          entity={Entity.whatsappBotSetting}
          action={SBRMAction.Update}
          disabled={!hasAccess(Permission.updateVenue)}
          metadata={[
            {
              key: MetadataKey.WhatsappBotSetting,
              value: WhatsappBotSettingKey.MANAGE_BOOKING_FLOW_BUTTON,
            },
            { key: MetadataKey.Venue, value: venueId },
          ]}
        />
      </Col>
      <Col span={12}>
        <Flex className="w-full" justify="center">
          <Image
            height={300}
            width={378}
            src="/assets/whatsapp-templates/edit-cancel-button.png"
          />
        </Flex>
      </Col>

      <Divider />
      <Col span={12}>
        <FormCard
          title="After booking message"
          entity={Entity.whatsappBotSetting}
          action={SBRMAction.Update}
          disabled={!hasAccess(Permission.updateVenue)}
          metadata={[
            {
              key: MetadataKey.WhatsappBotSetting,
              value: WhatsappBotSettingKey.AFTER_BOOKING_MESSAGE,
            },
            { key: MetadataKey.Venue, value: venueId },
          ]}
        />
      </Col>
      <Col span={12}>
        <Flex className="w-full" justify="center">
          <Image
            height={300}
            width={378}
            src="/assets/whatsapp-templates/confirmation-message.png"
          />
        </Flex>
      </Col>
      <Divider />
      <Col span={12}>
        <FormCard
          title="After booking update message"
          entity={Entity.whatsappBotSetting}
          action={SBRMAction.Update}
          disabled={!hasAccess(Permission.updateVenue)}
          metadata={[
            {
              key: MetadataKey.WhatsappBotSetting,
              value: WhatsappBotSettingKey.AFTER_BOOKING_UPDATE_MESSAGE,
            },
            { key: MetadataKey.Venue, value: venueId },
          ]}
        />
      </Col>
      <Col span={12}>
        <Flex className="w-full" justify="center">
          <Image
            height={300}
            width={378}
            src="/assets/whatsapp-templates/after-edit-text.png"
          />
        </Flex>
      </Col>
      <Divider />
      <Col span={12}>
        <FormCard
          title="After booking cancellation message"
          entity={Entity.whatsappBotSetting}
          action={SBRMAction.Update}
          disabled={!hasAccess(Permission.updateVenue)}
          metadata={[
            {
              key: MetadataKey.WhatsappBotSetting,
              value: WhatsappBotSettingKey.AFTER_BOOKING_CANCEL_MESSAGE,
            },
            { key: MetadataKey.Venue, value: venueId },
          ]}
        />
      </Col>
      <Col span={12}>
        <Flex className="w-full" justify="center">
          <Image
            height={300}
            width={378}
            src="/assets/whatsapp-templates/after-cancel.png"
          />
        </Flex>
      </Col>
      <Divider />
      <Col span={12}>
        <FormCard
          title="Payment link message"
          disabled={!hasAccess(Permission.updateVenue)}
          entity={Entity.whatsappBotSetting}
          action={SBRMAction.Update}
          metadata={[
            {
              key: MetadataKey.WhatsappBotSetting,
              value: WhatsappBotSettingKey.LINK_PAYMENT_MESSAGE,
            },
            { key: MetadataKey.Venue, value: venueId },
          ]}
          footer={
            <Alert
              type="info"
              title={
                <Space orientation="vertical">
                  <Text>
                    You can insert variable by clicking on the button copied
                    below.
                  </Text>
                  <Space>
                    <Tag variant="outlined">
                      <Text copyable>%LINK%</Text>
                    </Tag>
                  </Space>
                </Space>
              }
            />
          }
        />
      </Col>
      <Col span={12}>
        <Flex className="w-full" justify="center">
          <Image
            height={300}
            width={378}
            src="/assets/whatsapp-templates/payment-link.png"
          />
        </Flex>
      </Col>
      <Divider />
    </Page>
  )
}

export default WhatsappBotSettingsTab
